// extracted by mini-css-extract-plugin
export default {"cls1":"ToolsMenu-cls1_lub","cls2":"ToolsMenu-cls2_fPS ToolsMenu-cls1_lub"};